import { createFileRoute, Outlet } from '@tanstack/react-router';
import { ensureSubdomain } from '../../../utils/subdomain';

// The staff app: everything under admin.<domain>. Anything reached on another host is bounced here.
export const Route = createFileRoute('/subdomain/admin')({
  beforeLoad: ensureSubdomain('admin'),
  component: Outlet,
});
